import { render } from "./SearchTemplate.vue?vue&type=template&id=28296368&scoped=true"
import script from "./SearchTemplate.vue?vue&type=script&lang=js"
export * from "./SearchTemplate.vue?vue&type=script&lang=js"

import "./SearchTemplate.vue?vue&type=style&index=0&id=28296368&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28296368"]])

export default __exports__